import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function getScreenHoldingCollections(
  authState: tsWhoAmI,
  screen_holding_id: string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/screen/getScreenHoldingCollections.php?ScreenHoldingID=${screen_holding_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const ScreenHoldingService = {
  getScreenHoldingCollections,
}

export default ScreenHoldingService
